import { PublicKey } from '@solana/web3.js';
import { buildRefundTx } from './buildRefundTx.js';
export async function refund(connection, signer, params, program) {
    const walletPublicKey = new PublicKey(signer.publicKey);
    const tx = await buildRefundTx(connection, program, walletPublicKey, params);
    try {
        const signature = await signer.sendTransaction(tx);
        const res = await connection.confirmTransaction({
            blockhash: tx.recentBlockhash,
            lastValidBlockHeight: tx.lastValidBlockHeight,
            signature,
        });
        if (res?.value.err) {
            throw new Error(res.value.err.toString());
        }
        return signature;
    }
    catch (error) {
        console.error('[SolanaHTLC] refund failed', error?.message ?? error, error?.logs ?? []);
        throw error;
    }
}
